module.exports = __webpack_public_path__ + "static/media/ListIcon.1b97c9e5.svg";